import React, { Component } from 'react';

export default class Barcode extends React.Component {

  constructor(props) {
    super(props);
    this.state = { status: '' }
  }


  handleImageError() {
    this.setState({ status: 'error' })
    setTimeout(function(){
       window.location.reload(1);
    }, 5000);
  }

  render() {

    const image = <img
            className='barcode'
            onError={() => this.handleImageError()}
            src={this.props.path}
            alt="barcode" />

          const loading = <div className='barcode' style={{border: '1px solid silver', backgroundColor: '#eee'}}> <h3 style={{width: 440, margin: '60px auto'}}>Barkod se učitava, pričekaj nekoliko sekundi...</h3> </div>

    return this.state.status === 'error' ? loading : image
  }

}



// WEBPACK FOOTER //
// app/frontend/components/Barcode.jsx